import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {Configuration} from '@shared/models/configuration';
import {take} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Api} from '@shared/constants/common-field.constants';
import {FlowChartDataService} from '@features/data-survey/services/flow-chart-data.service';
import {CellValue} from "@shared/models/paged-response-model";

@Component({
    standalone: false,
    selector: 'particle-platform-tool-questionnaire-response-group-container',
  templateUrl: './platform-tool-question-response-group.component.html',
  styleUrls: ['./platform-tool-question-response-group.component.scss']
})
export class PlatformToolQuestionResponseGroupComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  sections: any = null;
  fieldVisibilities: any;
  fieldDefinitions: any;
  rowItem: any;
  defaultExpansionPanelIndex = 0;
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  selectedIndex: number;
  sourceSectionId: string;
  items: any;
  isFlowExecution: boolean;
  hidePagination: boolean;
  flowchart: any;

  selectedItem: any;
  showMultipleColumnComboBox: any;
  sourceKey: any;
  api: any;
  serviceName: any;
  displayKey: any;
  displayKeys: any[];
  valueProperty: any;
  showedFieldKeys: any;
  sortField: any;
  parameters: any;
  valueKey: any;
  selectedItemsId : any[];
  itemsCount: any;
  selectedSectionId: any;

  constructor(private httpClient: HttpClient,
              private flowChartDataService: FlowChartDataService) {
  }

  ngOnInit() {
    console.log('query flowchart:', this.selectedTab.tabData['FlowchartQuery']);
    this.items = this.selectedTab.tabData['Items'] ?? [];
    this.hidePagination = this.selectedTab.tabData['HidePagination'] === true;
    this.isFlowExecution = this.selectedTab.tabData['IsFlowExecution'] ?? false;
    this.selectedIndex = this.selectedTab.tabData['SelectedIndex'] ?? 1;
    this.sourceSectionId = this.selectedTab.tabData['SourceSectionId'];
    this.flowChartDataService.setApi(this.selectedTab.tabData.Api);
    this.createConfig(this.selectedTab.tabData);
    this.setComboBoxData();
    this.httpClient.post<any>(`${Configuration.getConfig(this.selectedTab.tabData['Api'])}Query/Flowchart`, this.selectedTab.tabData['FlowchartQuery']).pipe(take(1)).subscribe(data => {
      this.rowItem = data.row;
      this.fieldDefinitions = data.fieldDefinitions;
      this.fieldVisibilities = data.fieldVisibilities;
      this.flowchart = data.flowcharts[0];
      console.log('[row data for flowchart qnr response]:', data);
      if (data.flowchartSections && data.flowchartSections[data.flowcharts[0].id]) {
        this.sections = data.flowchartSections[data.flowcharts[0].id];
        this.setDefaultExpandedPanelIndex(this.sections, this.sourceSectionId);
      }
    });
  }

  setComboBoxData() {
    this.showMultipleColumnComboBox = this.selectedTab.tabData['ShowMultipleColumnComboBox'];
    this.sourceKey = this.selectedTab.tabData['SourceKey'];
    this.api = this.selectedTab.tabData['Api'];
    this.serviceName = this.selectedTab.tabData['ServiceName'];
    this.displayKey = this.selectedTab.tabData['DisplayKey'];
    this.valueProperty = this.selectedTab.tabData['ValueProperty'];
    this.showedFieldKeys = this.selectedTab.tabData['ShowedFieldKeys'];
    this.sortField = this.selectedTab.tabData['SortField'];
    this.parameters = this.selectedTab.tabData['Parameters'];
    this.displayKeys = this.selectedTab.tabData['DisplayKeys'];
    // console.log( "+++++++++++++++++++++++++++++++++, ", this.items);
    this.selectedItemsId = [this.items.find(x => x.text === (this.selectedIndex + 1).toString())?.id];
    this.itemsCount = this.selectedTab.tabData['ItemsCount'];
  }

  onFormValuesChanged($event) {
    this.selectedItem = $event[0];
    const dataItemId = this.selectedItem?.id;
    this.selectedItemsId = [dataItemId];
    this.openSelectedResponse(dataItemId);
  }

  ngOnDestroy(): void {
    this.flowChartDataService.destroy();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }
  openSelectedResponse(dataItemId: any) {
    let command = this.magicLinkModel.additionalCommands['OpenFileCommand'] as PlatformCommand;
    if (this.isFlowExecution) {
      command = this.magicLinkModel.additionalCommands['NavigateToOpenFileCommand'] as PlatformCommand;
      command.fieldValues['ShouldResetBreadCrumbs'] = false;
    }
    setTimeout(() => {
      command.fieldValues['DataItemId'] = dataItemId;
      command.fieldValues['ViewMode'] = 'response';
      command.fieldValues['FlowchartSectionId'] = this.selectedSectionId;
      this.handler.executeCommand(command);
    }, 0);
  }
  changePage(change: number) {
    if (this.selectedIndex + change < 0 || this.selectedIndex + change + 1 > this.itemsCount) {
      return;
    }
    this.selectedIndex += change;
    if (change === 1) {
      this.openSelectedResponse(this.items[this.items.length - 1].id);
    } else {
      this.openSelectedResponse(this.items[0].id);
    }
  }

  createConfig(parameters) {
    let smartConfig = Configuration.getSmartGridConfig(parameters['SourceType']);
    if (!smartConfig) {
      smartConfig = {
        'SourceType': parameters['SourceType'],
        'IsCompanySpecific': parameters['IsCompanySpecific'] === true,
        'RootUrlKey': parameters['Api'],
        'ItemsUrlIndex': 0,
        'ItemsUrl': [],
        'Parameters': {},
        'SelectionSettings' : {
          'ShowCheckAll' : parameters['ShowCheckAll'] === true,
          'CheckboxOnly' : parameters['ShowCheckbox'] === true,
          'Mode' : parameters['AllowMultipleCheck'] ? 'multiple' : 'single',
          'Enabled': parameters['ShowCheckbox'] === true
        }

      };
      Configuration.setSmartGridConfig(parameters['SourceType'],  smartConfig);
    }
  }

  onUpdatedRowItem(rowItem: any) {
    if (rowItem) {
      this.rowItem = rowItem;
    }
  }

  private  setDefaultExpandedPanelIndex(sections: any[], sourceSectionId: string) {
    if (!sections || sections.length === 0 || !sourceSectionId) {
      return;
    }
    const sourceSectionIndex = sections.findIndex(section => section.id === this.sourceSectionId);
    if(sourceSectionIndex > -1)
    {
      this.defaultExpansionPanelIndex = sourceSectionIndex;
      this.onSectionChange(this.sections[this.defaultExpansionPanelIndex]);
    }
  }

  onSectionChange(section: any) {
    const fieldKeys: any = this.getShowFieldKeys(section);

    if (fieldKeys.length > 0) {
      this.displayKey = fieldKeys[0];
    }

    this.displayKeys = fieldKeys;
    this.showedFieldKeys = this.convertToCommaSeparatedWithSpaceAfterComma(fieldKeys);
    this.parameters['SurveyFlowchartSectionId'] = section.id;
    this.parameters['FIELD_SECTION_ID'] = section.id;
    this.selectedSectionId = section.id;
  }

  getShowFieldKeys(section: any) {
    const openSectionQuestions = this.flowChartDataService.getAllFlatQuestions(section);
    let fieldsToTake = 3;
    const fieldKeys: any = [];
    for (let i = 0; i < openSectionQuestions.length && fieldsToTake > 0; ++i) {
      if (openSectionQuestions[i].identityField) {
        fieldKeys.push(openSectionQuestions[i].fieldKey);
        --fieldsToTake;
      }
    }

    for (let i = 0; i < openSectionQuestions.length && fieldsToTake > 0; ++i) {
      if (fieldKeys.find(x => x === openSectionQuestions[i].fieldKey)) {
        continue;
      }
      fieldKeys.push(openSectionQuestions[i].fieldKey);
      --fieldsToTake;
    }
    return fieldKeys;
  }

  convertToCommaSeparatedWithSpaceAfterComma(fieldKeys: any) {
    if (fieldKeys.length === 0) { return; }
    let keys = '';
    for (let i = 0; i < fieldKeys.length - 1; ++i) {
      keys += fieldKeys[i] + ', ';
    }
    keys += fieldKeys[fieldKeys.length - 1];
    return keys;
  }
}
